<!--  -->
<template>
  <div class>
    <!-- 导航栏 -->
    <div class="nav-bar">
      <div class="nav-box">
        <img src="@/assets/img/position/back.png" class="nav-img" @click="bindtaps(0)" />
        <span>详情</span>
        <div class="nav-item">
          <img src="@/assets/img/position/share.png" class="nav-img" @click="bindtaps(1)" />
          <img src="@/assets/img/position/backHome.png" class="nav-img" @click="bindtaps(2)" />
        </div>
      </div>
    </div>
    <div class="content">
      <p class="title">{{details.title}}</p>
      <div class="text" v-html="details.content"></div>
    </div>
    <van-share-sheet v-model="showShare" title="立即分享给好友" :options="options" @select="onSelect" />
    <div class="overly" v-if="show" @click="show=false"></div>
    <img src="../../assets/img/home/share.png" class="share" v-if="show" @click="show=false" />
  </div>
</template>

<script>
import { getArticleDetails } from "@/api/apiData";
import { Toast } from "vant";
export default {
  components: {},
  data() {
    return {
      id: "",
      details: "",
      showShare: false,
      show:false,
      options: [
        { name: "微信", icon: "wechat", type: "wechat" },
        { name: "微博", icon: "weibo", type: "sina" }
      ]
    };
  },
  computed: {},
  methods: {
    // 返回  分享 收藏
    bindtaps(val) {
      var that = this;
      if (val == 0) {
        // 返回上一页
        that.$router.back();
      } else if (val == 1) {
        // 分享

        that.showShare = true;
      } else {
        //  返回首页
        that.$router.replace({
          name: "Home"
        });
      }
    },
    onSelect(option) {
      var type = option.type;
      //新浪微博接口的传参
      if (type == "sina") {
        // //(document.location.href);
        window.open(
          "http://service.weibo.com/share/share.php?url=" +
            document.location.href +
            "?id=" +
            this.id
        );
      }
      // 微信分享
      if (type == "wechat") {
        this.show = true;
      }
      this.showShare = false;
    },
    // 获取详情
    getDetails() {
      var that = this;
      var id = that.id;
      getArticleDetails({
        article_id: id
      }).then(res => {
        //(res);
        if (res.code == 1) {
          that.details = res.data;
        } else {
          Toast(res.msg);
        }
      });
    }
  },
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
    this.getDetails();
  }
};
</script>
<style lang='less' scoped>
// 导航栏
.nav-bar {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  font-size: 0.32rem;
  font-weight: bold;
  text-align: center;
  color: rgba(51, 51, 51, 1);
  .nav-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.2rem 0.32rem;
    z-index: 999;
    background: #fff;
    .nav-img {
      width: 0.4rem;
      height: 0.4rem;
    }
    .nav-item {
      display: flex;
      align-items: center;
      width: 15%;
      justify-content: space-between;
    }
  }
}
.overly {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
}
.share {
  width: 3rem;
  height: 3rem;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
}
.nav-bar::after {
  content: "";
  display: block;
  height: 0.8rem;
  width: 100%;
}
.content {
  padding: 0.3rem 0.32rem;
  width: 100%;
  p {
    font-size: 0.3rem;
    font-weight: bold;
    line-height: 0.42rem;
    padding-bottom: 0.3rem;
  }
  .text {
    width: 100%;
    font-size: 0.26rem;
    color: rgba(51, 51, 51, 1);
  }
  /deep/.text img{
    max-width: 100%;
    margin:auto;
  }
}
</style>